import { Pipe, PipeTransform } from '@angular/core';
import { getName, User } from '@marmon/shared/types/user';

@Pipe({
	name: 'name',
	standalone: true,
})
export class NamePipe implements PipeTransform {
	transform(value: User) {
		return getName(value);
	}
}
